import React__default from 'react';
import '../utils/assertion.esm.js';
import '../utils/ssr.esm.js';
import '../utils/number.esm.js';
import '../utils/array.esm.js';
import '../utils/breakpoint.esm.js';
import '../utils/context.esm.js';
import { isBrowser } from '../utils/dom.esm.js';
import '../utils/tabbable.esm.js';
import '../utils/dom-query.esm.js';
import '../utils/logger.esm.js';
import '../utils/focus.esm.js';
import '../utils/function.esm.js';
import '../utils/keydown.esm.js';
import '../utils/lazy.esm.js';
import '../utils/object.esm.js';
import '../utils/react-helpers.esm.js';
import '../utils/style-props.esm.js';
import '../utils/tailwind.esm.js';

function useKeyPress(targetKey, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      modifiers = _options.modifiers,
      preventDefault = _options.preventDefault; // State for keeping track of whether key is pressed

  var _React$useState = React__default.useState(false),
      keyPressed = _React$useState[0],
      setKeyPressed = _React$useState[1]; // Build a list of the enabled modifier keys


  var modifierKeys = modifiers ? Object.entries(modifiers).filter(function (_ref) {
    var v = _ref[1];
    return v;
  }).map(function (_ref2) {
    var k = _ref2[0];
    return k;
  }) : [];

  function downHandler(event) {
    if (event.key !== targetKey) {
      return;
    } // Handler to preventDefault and set state


    var setPressed = function setPressed(pressed) {
      if (pressed && preventDefault) {
        event.preventDefault();
      }

      setKeyPressed(pressed);
    }; // If pressed key is our target key and no modifiers, then set to true


    if (!modifierKeys.length) {
      setPressed(true);
      return;
    } // Check that modifiers are also pressed


    var keys = modifierKeys.map(function (k) {
      return k + "Key";
    });
    setPressed(keys.every(function (k) {
      return event[k];
    }));
  }

  var upHandler = function upHandler(event) {
    var _event$key;

    // If released key is our target key then set to false
    if (event.key === targetKey) {
      setKeyPressed(false);
      return;
    } // Check if it was a modifier key that was released
    // Note: event.key could be undefined on mobile browsers


    if (modifierKeys.includes((_event$key = event.key) == null ? void 0 : _event$key.toLowerCase())) {
      setKeyPressed(false);
    }
  }; // Add event listeners


  React__default.useEffect(function () {
    if (!isBrowser) {
      return undefined;
    }

    window.addEventListener('keydown', downHandler);
    window.addEventListener('keyup', upHandler); // Remove event listeners on cleanup

    return function () {
      window.removeEventListener('keydown', downHandler);
      window.removeEventListener('keyup', upHandler);
    };
  }, []); // Empty array ensures that effect is only run on mount and unmount

  return keyPressed;
}

export { useKeyPress };
//# sourceMappingURL=use-key-press.esm.js.map
